<!DOCTYPE html>

<body class="static-contant">
    <section>
        <div class="container1440">
            <div class="security">
                <h6 class="google">Security > Google Authentication</h6>
                <div class="e-bled">
                    <h1>Enabled Google Authenticator</h1>
                </div>
                <div class="download-app">
                    <ul>
                        <li class="active">Download App
                            <p class="active">1</p>
                        </li>
                        <li>
                            Scan QR Code
                            <p class="active">2</p>
                        </li>
                        <li>
                            Backup Key
                            <p>3</p>
                        </li>
                        <li>
                            Enabled Google Authenticator
                            <p>4</p>
                        </li>
                    </ul>
                </div>

                <div class="scan_code">
                    <div class="scan"><img src="assets/images/scan.png" alt=""></div>
                    <div class="are-you">
                        <p>If you are unable to scan the QR code, Please enter
                            this code manually into the app.</p>
                        <button>AJBCZFG</button>
                    </div>
                </div>
                <div class="pre"><a (click)="back()">
                        << Prev Step</a> </div> <div class="send_button">
                            <button (click)="next()">NEXT</button>
                </div>
            </div>
        </div>
    </section>
</body>